import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { USER_UPDATED } from '@gig/magic-messages';
import '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import '../../services/notifications/notifications.service.js';
import { liveChatService } from '../../services/live-chat/live-chat.service.js';
import { init } from './liveagent-controller.js';

/**
 * Component for Live Agent live chat. This component should always be visible
 * in the page, and to actually open it you have to call
 * `liveChatService.openLiveAgent()`
 */
var LiveAgentComponent = /** @class */ (function (_super) {
    __extends(LiveAgentComponent, _super);
    function LiveAgentComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.unsubscribe = null;
        _this.initialised = false;
        return _this;
    }
    LiveAgentComponent.prototype.mounted = function () {
        var _this = this;
        this.unsubscribe = liveChatService.onLiveChatStateChange(function (isOpen) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isOpen) {
                            return [2 /*return*/];
                        }
                        if (!!this.initialised) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initialiseLiveAgent()];
                    case 1:
                        _b.sent();
                        this.initialised = true;
                        _b.label = 2;
                    case 2:
                        (_a = this.liveAgentController) === null || _a === void 0 ? void 0 : _a.openChat();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    LiveAgentComponent.prototype.destroyed = function () {
        var _a, _b, _c;
        (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.languageSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.loggedInSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    };
    LiveAgentComponent.prototype.initialiseLiveAgent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var liveChat, _a, id, trackScriptUrl, chatId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.queryChatConfig()];
                    case 1:
                        liveChat = _b.sent();
                        _a = liveChat, id = _a.id, trackScriptUrl = _a.trackScriptUrl, chatId = _a.chatId;
                        return [4 /*yield*/, this.loadLiveAgent(id, trackScriptUrl)];
                    case 2:
                        _b.sent();
                        this.updateUserDetails();
                        return [4 /*yield*/, this.createChatButton(chatId)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LiveAgentComponent.prototype.queryChatConfig = function () {
        return configQuery('liveChat');
    };
    LiveAgentComponent.prototype.loadLiveAgent = function (id, trackScriptUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, init({
                                id: id,
                                trackScriptUrl: trackScriptUrl,
                                onClose: function () {
                                    liveChatService.liveAgentClosed();
                                },
                            })];
                    case 1:
                        _a.liveAgentController = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LiveAgentComponent.prototype.updateUserDetails = function () {
        var _this = this;
        this.loggedInSubscription = window.eventBus.subscribe(USER_UPDATED, function (event) {
            _this.liveAgentController.addUserDetails(event.payload);
        }, { replay: true });
    };
    LiveAgentComponent.prototype.createChatButton = function (chatId) {
        return this.liveAgentController.createButton(chatId);
    };
    LiveAgentComponent = __decorate([
        Component({
            name: 'liveagent',
        })
    ], LiveAgentComponent);
    return LiveAgentComponent;
}(Mixins(MagicConfigMixin)));

export default LiveAgentComponent;
